<template>
  <dialog-v2
    :show="show"
    :title="title"
    max-width="600px"
    @close="$emit('close')"
    @save="save">
    <template slot="content">
      <v-layout row wrap justify-center align-center mb-3>
        <v-flex>
          <v-checkbox
            v-model="form.enabled"
            @change="form.failed_attempts = null"
            :hide-details="true"
            label="Gestión en paralelo" />
        </v-flex>
        <v-flex md5 text-xs-right>
          <v-select
            v-model="form.failed_attempts"
            solo
            flat
            class="grey"
            placeholder="Intentos fallidos"
            color="black"
            item-value="text"
            :items="numbers"
            :hide-details="true"
            :disabled="!form.enabled"
            autocomplete/>
        </v-flex>
      </v-layout>
      <v-layout row wrap mt-3>
        <v-flex>
          <p>
            Seleccione la cantidad de notificaciones fallidas de {{ channel }} para iniciar gestión humana
            y digital en paralelo.
          </p>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import { setTimeout } from 'timers';
import EventBus from '@/event-bus';
import DialogV2 from '@/components/global/DialogV2';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    channel: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    DialogV2,
  },
  data() {
    const emptyForm = {
      enabled: false,
      failed_attempts: null,
    };
    const numbers = [];
    for (let i = 0; i <= 100; i += 1) {
      numbers.push({
        text: i,
      });
    }
    return {
      numbers,
      emptyForm,
      form: {
        ...emptyForm,
      },
    };
  },
  computed: {
    title() {
      return `Gestión en paralelo de ${this.channel}`;
    },
  },
  methods: {
    save() {
      if (this.form.enabled && !this.form.failed_attempts) {
        EventBus.$emit('modal', 'Para activar la gestión en paralelo debe seleccionar un número de intentos fallidos.');
      } else {
        this.$emit('save', this.form);
        this.$emit('close');
      }
    },
  },
  watch: {
    show() {
      if (!this.show) {
        setTimeout(() => {
          this.form = {
            ...this.emptyForm,
          };
        }, 200);
      } else if (Object.keys(this.data).length) {
        this.form = {
          ...this.data,
        };
      }
    },
  },
};
</script>

<style scoped>
.grey {
  background-color: #eee !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CollectWorkflows/MultipleManagementDialog.vue